<!-- 学科资源分布 --> 
<template>
    <div class="subject-rsources-distribution-chart">
        <div class="subject-rsources-distribution-chart-title">
            <div class="name">学科资源分布</div>
            <div class="phase">
                <div :class="phaseName == '1' ? 'is-select' : ''" @click="selectPhaseBtn('1')">小学 </div><span></span>
                <div :class="phaseName == '2' ? 'is-select' : ''" @click="selectPhaseBtn('2')">初中 </div><span></span>
                <div :class="phaseName == '3' ? 'is-select' : ''" @click="selectPhaseBtn('3')">高中</div>
            </div>
        </div>
        <div class="chart" id="subjectrsourcesdistributionchart" v-show="isShow"></div>
        <div class="chart-error" v-show="!isShow">
            <div class="detail">
                <span class="detail">暂无数据!</span>
            </div>
        </div>
    </div>
</template>
<script>
import { getPlatformSubjectResourceStatAPI } from "@/service/api.js"
export default {
    name: 'subject-rsources-distribution-chart',
    props: {
        //区域id
        regionId: {
            type: String,
            default: ''
        },
        //省id
        provinceId: {
            type: String,
            default: ''
        },
        //市id
        cityId: {
            type: String,
            default: ''
        },
        //区id
        districtId: {
            type: String,
            default: ''
        },
        //乡镇地址
        address: {
            type: String,
            default: ''
        },
        //开始时间
        startTime: {
            type: String,
            default: ""
        },
        //结束时间
        endTime: {
            type: String,
            default: ""
        },
    },
    data() {
        return {
            phaseName: '1',
            //学段学科数据
            subjectDate: "",
            isShow: "true"
        }
    },
    computed: {
        intervalTime() {
            return [this.startTime, this.endTime];
        }
    },
    watch: {
        intervalTime() {
            this.getStateresource();
        },
        schoolId() {
            this.getStateresource();
        },
        address() {
            this.getStateresource();
        }
    },
    methods: {

        /**
   * @name 初始化echarts图表
   */
        initEchart() {
            let _this = this;
            let nameList = _this.subjectDate.map((item) => {
                return item.subjectName
            })
            let numberList = _this.subjectDate.map((item) => {
                return item.rsNum
            })
            let dataSource = _this.$echarts.init(
                document.getElementById('subjectrsourcesdistributionchart')
            );
            const option = {
                grid: {
                    left: '7%',
                    top: '20%',
                    bottom:'15%',
                    right:'7%'
                },
                xAxis: {
                    axisTick: false,
                    type: 'category',
                    data: nameList,
                    axisLine: {
                        show: true,//是否显示轴线
                        lineStyle: {
                            color: '#6076AD',//刻度线的颜色
                            width: 2
                        }
                    },
                    axisLabel: {
                        interval: 0,
                        color: '#708ACC',
                        formatter: function (value) {
                            if (value) {
                                if (value.length > 4) {
                                    let nameList = [];
                                    for (var i = 0; i < value.length; i += 4) {
                                        nameList.push(value.substring(i, i + 4));
                                    }
                                    return nameList.join("\n")
                                } else {
                                    return value
                                }
                            }
                        }
                    }
                },
                yAxis: {
                    type: 'value',
                    axisTick: false,
                    axisLine: false,
                    splitLine: {
                        lineStyle: {
                            color: '#233162',
                        }
                    },
                    axisLabel: {
                        color: '#708ACC',
                    },
                },
                color: {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [{
                        offset: 0, color: '#64EFB8 ' // 0% 处的颜色
                    }, {
                        offset: 1, color: '#36B381' // 100% 处的颜色
                    }],
                    global: false
                },
                legend: {
                    show: true,
                    icon: "circle",
                    top: '5%',
                    right: '2%',
                    textStyle: {
                        color: '#fff'
                    }
                },
                series: [
                    {
                        name: '建设',
                        data: numberList,
                        barWidth: 18,
                        type: 'bar',
                        label: {
                            show: true,
                            position: 'top',
                            color: '#fff'
                        },
                        itemStyle: {
                            barBorderRadius: [4, 4, 0, 0]
                        }
                    },
                ]
            }
            dataSource.setOption(option);
            window.addEventListener("resize", function () {
                dataSource.resize();
            });
        },
        /**
       * @name 获取各学段学科资源
       */
        async getStateresource() {
            try {
                let params = {
                    regionId: this.regionId,
                    provinceId: this.provinceId,
                    cityId: this.cityId,
                    districtId: this.districtId,
                    address: this.address,
                    startTime: this.startTime ? `${this.startTime} 00:00:00` : '',
                    endTime: this.endTime ? `${this.endTime} 23:59:59` : '',
                    phase: this.phaseName
                }
                this.subjectDate = await getPlatformSubjectResourceStatAPI(params)
                this.isShow = this.subjectDate.length == 0 ? false : true;
                //初始化图表
                this.initEchart();
            } catch (err) { }
        },
        /**
         * @name 切换
         */
        selectPhaseBtn(type) {

            if (this.phaseName == type) {
                return;
            }
            this.phaseName = type;
            this.getStateresource();
        },

    },
    mounted() {
        //  获取各学段学科资源
        this.getStateresource();
    }
}

</script>
<style lang="scss" scoped>
.subject-rsources-distribution-chart {
    margin-top: 25px;
    width: 100%;
    height: 300px;
    background: rgba(9, 19, 66, 0.6);
    border: 1px solid #427CC2;
    border-radius: 0px 0px 4px 4px;

    .subject-rsources-distribution-chart-title {
        background: url("~@/assets/images/qingxudataboard/center_center_bg.png") no-repeat;
        background-size: 100% 100%;
        width: 100%;
        height: 40px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 13px 0 18px;

        .name {
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #FFFFFF;
        }

        .phase {
            display: flex;
            align-items: center;
            cursor: pointer;

            & div {
                padding: 2px 0;
                font-size: 16px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #FFFFFF;

                &:hover {
                    color: #38FFF3;
                    font-weight: bold;
                }
            }

            & span {
                width: 1px;
                height: 15px;
                background-color: #38FFF3;
                opacity: .3;
                margin: 0 5px;

            }


            .is-select {
                font-size: 16px;
                font-family: Microsoft YaHei;
                font-weight: bold;
                color: #38FFF3;
                border-bottom: 2px solid transparent;
                -webkit-border-image: url("~@/assets/images/qingxudataboard/is_selected.png") 0 0 2 0 round;
                /* Safari 5 and older */
                -o-border-image: url("~@/assets/images/qingxudataboard/is_selected.png") 0 0 2 0 round;
                /* Opera */
                border-image: url("~@/assets/images/qingxudataboard/is_selected.png") 0 0 2 0 round;
            }
        }
    }

    .chart {
        width: 100%;
        height: 260px;
    }

    .chart-error {
        width: 100%;
        height: 260px;
        display: flex;
        align-items: center;
        justify-content: center;

        .detail {
            font-size: 16px;
            color: #fff;
        }
    }
}
</style>